import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { ButtonModule } from '@ui/form/button/button.module';
import {
    ChangeInvoiceStatusFormData,
    ChangeInvoiceStatusFormService,
    FormChangeInvoiceStatusFormField,
} from './form-change-invoice-status-form.service';
import { B2bProgramInvoicesState } from '../../../../shared/state/b2b-program-invoices.state';
import {
    ListB2BInvoiceStatusResponse,
} from '@api/models/B2bService/Contract/Invoice/list-b-2-b-invoice-status-response';
import { DialogActions } from '@ui/dialog-v2/dialog-actions/dialog-actions';
import { TranslatePipe } from '@ngx-translate/core';
import { FieldTree } from '@angular/forms/signals';
import { SignalFormSelect } from '@ui/form/signal-form/signal-form-select/signal-form-select';


/**
 * B2b invoice change status
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'b2b-form-change-invoice-status',
    templateUrl: './form-change-invoice-status.component.html',
    styleUrls: ['./form-change-invoice-status.component.scss'],
    imports: [
        ButtonModule,
        AsyncPipe,
        DialogActions,
        TranslatePipe,
        SignalFormSelect,
    ],
    providers: [ChangeInvoiceStatusFormService],
})
export class FormChangeInvoiceStatusComponent {
    /**
     * Server pending flag
     */
    @Input() public pending: boolean;
    /**
     * Submit form event
     *
     * @returns Form data
     */
    @Output() public submitForm: EventEmitter<number> = new EventEmitter<number>();

    readonly #b2bProgramInvoicesState: B2bProgramInvoicesState = inject(B2bProgramInvoicesState);
    readonly #changeInvoiceStatusFormService: ChangeInvoiceStatusFormService = inject(ChangeInvoiceStatusFormService);

    public readonly statuses$: Observable<ListB2BInvoiceStatusResponse[]> = this.#b2bProgramInvoicesState.statuses$;
    public readonly form: FieldTree<ChangeInvoiceStatusFormData> = this.#changeInvoiceStatusFormService.createSignalForm();

    /**
     * Current invoice status
     */
    @Input()
    public set stCode(stCode: number) {
        if (stCode) {
            this.#changeInvoiceStatusFormService.patch({ stCode });
        }
    }

    public handlerConfirm(): void {
        this.submitForm.emit(this.form().value()[FormChangeInvoiceStatusFormField.StCode]);
    }
}
